const KEY = 'caprock:views';

export interface SavedView {
  id: string;
  name: string;
  href: string;
  createdAt: string;
}

interface Store {
  items: SavedView[];
}

function read(): Store {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { items: [] };
    const parsed = JSON.parse(raw) as Store;
    if (!Array.isArray(parsed.items)) return { items: [] };
    return parsed;
  } catch {
    return { items: [] };
  }
}

function write(store: Store) {
  localStorage.setItem(KEY, JSON.stringify(store));
  window.dispatchEvent(new Event('caprock:views'));
}

export function listViews(): SavedView[] {
  return read().items;
}

export function saveView(name: string, href: string): SavedView {
  const view: SavedView = {
    id: crypto.randomUUID(),
    name,
    href,
    createdAt: new Date().toISOString(),
  };
  write({ items: [view, ...read().items].slice(0, 40) });
  return view;
}

export function deleteView(id: string): void {
  write({ items: read().items.filter((item) => item.id !== id) });
}
